import type {CSSProperties, RefObject} from 'react';
import type {MeasuringConfiguration} from '@dnd-kit/core';
import type {Page} from '@PosterWhiteboard/page/page.class';

export const ITEM_ICON = 'icon-templates-stack';
export const ITEM_LABEL_KEY = 'pmwjs_layer_item';
export const GROUP_ICON = 'icon-templates-stack';
export const GROUP_LABEL_KEY = 'pmwjs_group';

export const SELECTION_CHECKBOX_ROLE_SELECTOR = '[role="checkbox"]';

export const DRAG_PLACEHOLDER_DATA_ATTRIBUTE = 'data-drag-placeholder';
export const SELECTED_ROW_DATA_ATTRIBUTE = 'data-selected';

export enum LayerType {
  Item = 'item',
  Group = 'group',
}

export interface LayerItemEntry {
  layerType: LayerType.Item;
  uid: string;
}

export interface LayerGroupEntry {
  layerType: LayerType.Group;
  groupId: string;
  memberUids: string[];
}

export type LayerEntry = LayerItemEntry | LayerGroupEntry;

export type DraggedLayer = {layerType: LayerType.Item; uid: string} | {layerType: LayerType.Group; entry: LayerGroupEntry};

/** What a row click should do, derived from the modifier keys held during the click. */
export enum SelectionIntent {
  Replace = 'replace',
  Toggle = 'toggle',
  Range = 'range',
}

export interface ApplySelectionOptions {
  /** Forwarded to Fabric so the selection event can be tagged (e.g. group drill-in). */
  selectionEvent?: MouseEvent;
}

export interface DragLayoutControls {
  listRef: RefObject<HTMLDivElement | null>;
  getScrollViewport: () => HTMLElement | null;
  measuring: MeasuringConfiguration;
  lockedBodyStyle: CSSProperties | undefined;
  lockLayout: () => void;
  releaseLayout: () => void;
}

export interface ReorderOuterRowsParams {
  activeId: string;
  overId: string;
  entries: LayerEntry[];
  draggedSortableIds: readonly string[];
  page: Page;
}

